import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cli-tabs',
  templateUrl: './cli-tabs.component.html',
  styleUrls: ['./cli-tabs.component.css']
})
export class CliTabsComponent implements OnInit {

  swLinkActivesMap = new Map<string, boolean>()
    .set('clientadhesions',false)
    .set('receivers',false);

  constructor(private router: Router,
              private location: Location) {
    this.initLinkActive();
  }

  ngOnInit() {
  }

  initLinkActive() {
    this.setLinkActive('clientadhesions');
    if (this.location.path()) {
      if (this.location.path().endsWith('autorizaciones')) {
        this.setLinkActive('clientadhesions');
      } else if (this.location.path().endsWith('receptores')) {
        this.setLinkActive('receivers');
      }
    }
  }

  onClientAdhesionsTabClicked() {
    this.setLinkActive('clientadhesions');
    this.router.navigate(['/cliente/autorizaciones']);
  }

  onReceiversTabClicked() {
    this.setLinkActive('receivers');
    this.router.navigate(['/cliente/receptores']);
  }

  isLinkActive(keyLink: string) : boolean {
    return this.swLinkActivesMap.get(keyLink);
  }

  setLinkActive(keyLink: string) {
    this.swLinkActivesMap
      .set('clientadhesions',false)
      .set('receivers',false);
    this.swLinkActivesMap.set(keyLink, true);
  }

}



// WEBPACK FOOTER //
// ./src/app/app-manager/client/cli-tabs/cli-tabs.component.ts